// src/Config/functions.js
// Configuração centralizada de Cloud Functions URLs
// Detecta automaticamente se está em produção ou sandbox

const FIREBASE_PROJECT = process.env.REACT_APP_FIREBASE_PROJECT || 'fidduxai-rowy';
const IS_SANDBOX = FIREBASE_PROJECT === 'fiddux-sandbox-dev';

// Local dev: usar URL completa (sem Hosting rewrite). Produção: /api/* (proxy same-origin, sem CORS)
const isLocalDev = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Base URL para Cloud Functions
const FUNCTIONS_BASE_URL = IS_SANDBOX
  ? 'https://us-central1-fiddux-sandbox-dev.cloudfunctions.net'
  : 'https://us-central1-fidduxai-rowy.cloudfunctions.net';

// URLs das Cloud Functions (v2: /api/* via Hosting rewrite evita CORS em produção)
export const FUNCTIONS_URLS = {
  // Email Functions
  SendAdminEmailIndividualPDF: `${FUNCTIONS_BASE_URL}/SendAdminEmailIndividualPDF`,
  SendPdfMonthlyPerformance: `${FUNCTIONS_BASE_URL}/SendPdfMonthlyPerformance`,
  SendAdminEmailPerformance: `${FUNCTIONS_BASE_URL}/SendAdminEmailPerformance`,
  sendCustomNotification: isLocalDev ? `${FUNCTIONS_BASE_URL}/sendCustomNotification` : '/api/sendCustomNotification',
  sendCustomEmailAndNotification: isLocalDev ? `${FUNCTIONS_BASE_URL}/sendCustomEmailAndNotification` : '/api/sendCustomEmailAndNotification',
  SendYieldTermsPdfToClient: `${FUNCTIONS_BASE_URL}/SendYieldTermsPdfToClient`,
  SendPdfYieldFinalPerformance: `${FUNCTIONS_BASE_URL}/SendPdfYieldFinalPerformance`,
  
  // Client History & Import
  ClientHistoryImportToolHttp: `${FUNCTIONS_BASE_URL}/ClientHistoryImportToolHttp`,
  ExtractContractMetadataFromPdfHttp: `${FUNCTIONS_BASE_URL}/ExtractContractMetadataFromPdfHttp`,
  ExtractIdentityFromDocumentHttp: `${FUNCTIONS_BASE_URL}/ExtractIdentityFromDocumentHttp`,
  KycReconciliationHttp: `${FUNCTIONS_BASE_URL}/KycReconciliationHttp`,
  
  // Ledgers & Balance
  FixUserLedgersToolHttp: `${FUNCTIONS_BASE_URL}/FixUserLedgersToolHttp`,
  InvestigateTransactionsWithoutLedgersHttp: `${FUNCTIONS_BASE_URL}/InvestigateTransactionsWithoutLedgersHttp`,
  FixAllUserBalancesFromLedgers: `${FUNCTIONS_BASE_URL}/FixAllUserBalancesFromLedgers`,
  
  // Reminders
  rescheduleReminder: `${FUNCTIONS_BASE_URL}/rescheduleReminder`,
  createAdminReminder: `${FUNCTIONS_BASE_URL}/createAdminReminder`,
  deleteAdminReminder: `${FUNCTIONS_BASE_URL}/deleteAdminReminder`,
  sendReminderNow: `${FUNCTIONS_BASE_URL}/sendReminderNow`,
  updateScheduledCronInterval: isLocalDev ? `${FUNCTIONS_BASE_URL}/updateScheduledCronInterval` : '/api/updateScheduledCronInterval',
  
  // Migration & Analysis
  PreviewProductionMigration: `${FUNCTIONS_BASE_URL}/PreviewProductionMigration`,
  ExecuteProductionMigration: `${FUNCTIONS_BASE_URL}/ExecuteProductionMigration`,
  AnalyzeDiscrepanciesComplete: `${FUNCTIONS_BASE_URL}/AnalyzeDiscrepanciesComplete`,
  
  // Collection CleanUp
  AnalyzeCollectionCleanUp: `${FUNCTIONS_BASE_URL}/AnalyzeCollectionCleanUp`,
  DeleteRowyDocuments: `${FUNCTIONS_BASE_URL}/DeleteRowyDocuments`,
  ImportSelectedDocuments: `${FUNCTIONS_BASE_URL}/ImportSelectedDocuments`,
};

// Log para debug (apenas em desenvolvimento)
if (process.env.NODE_ENV === 'development') {
  console.log(`🔧 Functions Config:`);
  console.log(`   Project: ${FIREBASE_PROJECT}${IS_SANDBOX ? ' (SANDBOX)' : ' (PRODUCTION)'}`);
  console.log(`   Base URL: ${FUNCTIONS_BASE_URL}`);
}

// Export para uso em outros arquivos
export const FIREBASE_CONFIG = {
  projectId: FIREBASE_PROJECT,
  isSandbox: IS_SANDBOX,
  functionsBaseUrl: FUNCTIONS_BASE_URL,
};

export default FUNCTIONS_URLS;
